import { services } from '@ambita/ambita-components-core';

services.i18n.registerTranslations('instantPurchase', {
  nb: {
    purchasePantebokIntro: 'Du kjøper nå en bekreftet pantebokkopi.',
    purchasePantebokOnCharging: `Du belastes for dette med en gang, og produktet vil bli sendt til deg per e-post.`,
    purchasePantebokOnAddingToOrderList: `Kostnaden for dette produktet blir ført opp på din fakturaspesifikasjon
    og i ordrelisten.`,
    cancel: 'Avbryt',
    charge: 'Belast',
    currencyShortNOK: 'kr',
    saveLookupPreference: 'belast og kjøp dette produktet direkte neste gang'
  },
  'en-us': {
    purchasePantebokIntro: 'You are now buying an Official copy of document from the Land Register',
    purchasePantebokOnCharging: `You will be charged for this at once, and the product will be sent to you by email.`,
    purchasePantebokOnAddingToOrderList: `The cost of this product will be allocated under your reference number
    in the order list and on the invoice specification.`,
    cancel: 'Cancel',
    charge: 'Charge',
    currencyShortNOK: 'kr',
    saveLookupPreference: 'charge and purchase this product directly next time'
  }
});
